import apiConfig from '../../../shared/config/apiConfig'
import { createBrandApiRequest } from '../../../shared/brand/utils/brandApiUtils'
import { mapBrandDocuments } from '../mappers/brandDocumentMapper'

export const createBrandDocumentService = ({
  brandsEndpoint = apiConfig.brandAPIs?.BRANDS,
  brandRequest,
} = {}) => {
  const request =
    brandRequest || createBrandApiRequest({ apiKey: apiConfig.apiKey || '' })

  return {
    getBrandDocuments: async (brand) => {
      const brandUuid = brand?.id || brand?.brandUuid || ''
      const response = await request({
        endpoint: `${brandsEndpoint}/${encodeURIComponent(brandUuid)}/details`,
      })
      return mapBrandDocuments(response)
    },

    deleteDocument: (documentId) =>
      request({
        endpoint: `${brandsEndpoint}/documents/${encodeURIComponent(documentId)}`,
        method: 'delete',
      }),
  }
}

export const brandDocumentService = createBrandDocumentService()
